module.exports = __webpack_public_path__ + "static/apartment-89187abe1cb0ef5fc8854ed4ef964c0a.jpg";